module.exports = __webpack_public_path__ + "media/images/mprarchive-white-f0a6895e2f185e0294338bfe5b81134c.svg";